// extracted by mini-css-extract-plugin
module.exports = {"buttonPrimary":"buttonprimary_buttonPrimary__2P4GJ","cancel":"buttonprimary_cancel__1lLhq"};